import React, { useEffect, useState } from "react";
import { useLocation } from "@tanstack/react-router";

const TIMINGS = {
  fadeStart: 1800,
  fadeDuration: 500,
};

export function LoadingScreen({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith("/admin");
  const hasLoadedBefore =
    typeof window !== "undefined" &&
    window.sessionStorage.getItem("pizza-steve-loaded") === "true";
  const shouldSkipLoading = isAdminPage || hasLoadedBefore;

  const [loading, setLoading] = useState(!shouldSkipLoading);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (shouldSkipLoading) return;

    const fadeTimer = window.setTimeout(() => {
      setFading(true);
      window.setTimeout(() => {
        setLoading(false);
        window.sessionStorage.setItem("pizza-steve-loaded", "true");
      }, TIMINGS.fadeDuration);
    }, TIMINGS.fadeStart);

    return () => window.clearTimeout(fadeTimer);
  }, [shouldSkipLoading]);

  if (shouldSkipLoading) return <>{children}</>;

  return (
    <>
      {children}
      {loading && (
        <div
          className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center transition-opacity duration-500 ${
            fading ? "pointer-events-none opacity-0" : "opacity-100"
          }`}
          style={{ background: "#0a0a0a" }}
        >
          <img
            src="https://res.cloudinary.com/dnggmrgmu/image/upload/w_120,f_auto,q_auto/v1782223973/pizza-steve_yfhhfj.png"
            alt="Mr. Pizza Steve Finds"
            style={{ width: 56, height: "auto", marginBottom: 28, opacity: 0.95 }}
          />

          <div
            style={{
              width: 140,
              height: 2,
              background: "rgba(255,255,255,0.12)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "100%",
                width: "40%",
                background: "#ff6a00",
                animation: "loadBar 1.1s ease-in-out infinite",
              }}
            />
          </div>

          <style>{`
            @keyframes loadBar {
              0% { transform: translateX(-100%); }
              100% { transform: translateX(350%); }
            }
          `}</style>
        </div>
      )}
    </>
  );
}